module.exports = __webpack_public_path__ + "static/img/banner_icon_03.f58e0a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_icon_03.png
// module id = 8B54
// module chunks = 0